import { NGXLogger } from 'ngx-logger';
import { Injectable, inject } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { BuyerService } from '../../buyer/services/buyer.service';
import { UserRegistrationService } from '../services/user-registration.service';
import { CompanyService } from '../services/company.service';

@Injectable({
  providedIn: 'root',
})
export class CompanyDetailsResolver implements Resolve<any> {
  private readonly logger = inject(NGXLogger);


  constructor(private userRegistrationService: UserRegistrationService, private router: Router) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.userRegistrationService.getCompanyDetails().pipe(
      tap((response) => {
        this.logger.debug(`CompanyDetailsResolver response is ${JSON.stringify(response)}`)
      }),
      catchError((error) => {
        this.logger.error(`CompanyDetailsResolver error is ${JSON.stringify(error)}`);
        this.router.navigate(['/error']); // Redirect on error
        return of(null);
      })
    );
  }
}